import { render, staticRenderFns } from "./AfterOtsComponent.vue?vue&type=template&id=dbcb8696&"
import script from "./AfterOtsComponent.vue?vue&type=script&lang=ts&"
export * from "./AfterOtsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbcb8696')) {
      api.createRecord('dbcb8696', component.options)
    } else {
      api.reload('dbcb8696', component.options)
    }
    module.hot.accept("./AfterOtsComponent.vue?vue&type=template&id=dbcb8696&", function () {
      api.rerender('dbcb8696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/OfficerTrainingSchoolFlyout/AfterOtsComponent.vue"
export default component.exports